import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  { path: '', redirectTo: 'sin', pathMatch: 'full' },
  {
    path: 'sin',
    loadChildren: () => import('./layouts/protected/protected.routes'),
    canActivate: [MsalGuard],
  },
  {
    path: 'logout',
    loadComponent: () => import('./domains/auth/logout/logout.component'),
  },
  {
    path: 'login-failed',
    loadComponent: () =>
      import('./domains/auth/login-failed/login-failed.component'),
  },
  {
    path: 'no-access',
    loadComponent: () => import('./core/pages/no-acces/no-acces.component'),
  },
  {
    path: 'redirect',
    redirectTo: 'sin',
  },
];
